import loadable from '@loadable/component';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import React from 'react';
import Banner from './Banner';
import ButtonCheckout from './ButtonCheckout';
import CookieConsent from './CookieConsent';
import Footer from './Footer';
import LogoLink from './LogoLink';
import MainMenu from './MainMenu';
import PagePaper from './PagePaper';

const Newsletter = loadable(() => import('./Newsletter'));

interface LayoutProps {}

export default function Layout(props: React.PropsWithChildren<LayoutProps>) {
  return (
    <div>
      <PagePaper>
        <Banner
          banner='Back in stock! Batverb tail-generating reverb pedal is waiting for you.'
          display={true}
          link='/products/batverb'
        />
        <Stack direction='row' display='flex' justifyContent='space-between'>
          <LogoLink />
          <MainMenu />
          <ButtonCheckout />
        </Stack>
        <Divider
          style={{ width: '100%' }}
          flexItem
          color='black'
          role='presentation'
          sx={{}}
        />
        {props.children}
        <Newsletter />
        <Footer />
        <CookieConsent />
      </PagePaper>
    </div>
  );
}
